module.exports = __webpack_public_path__ + "img/IcnMbFb.6ee66003.png";